import React from 'react'
import dynamic from 'next/dynamic'
import AppDrawer from '@components/Sidebar/AppDrawer'
import Navigation from '@components/organisms/Navigation'
import { ArticlePage } from '@containers/ArticlePage/'
import {
  GetArticleDocument,
  GetAdDistributionManagementDocument,
  GetArticlePageDocument,
  ArticleFragment,
  AdDeliveryDestination,
} from '@services/graphcms/client'
import { initializeApollo } from '@graphql/apolloClient'

const DynamicFooter = dynamic(import('../../components/organisms/Footer'), {
  ssr: false,
})

export default function Article() {
  return (
    <>
      <AppDrawer>
        <ArticlePage />
        <DynamicFooter />
        <Navigation />
      </AppDrawer>
    </>
  )
}

export async function getStaticProps(context: any) {
  const apolloClient = initializeApollo()

  const articleData = await apolloClient.query({
    query: GetArticleDocument,
    variables: {
      id: context.params.id as string,
    },
  })

  const nextSeoValues = {
    title: articleData?.data?.article?.title,
    description: articleData?.data?.article?.excerpt || '',
    canonical: `https://coataz.com/article/${articleData?.data?.article?.id}`,
    openGraph: {
      url: `https://coataz.com/article/${articleData?.data?.article?.id}`,
      title: articleData?.data?.article?.title,
      description: articleData?.data?.article?.excerpt || '',
      images: [
        {
          url: articleData?.data?.article?.thumbnail?.url || '',
        },
      ],
    },
  }

  await apolloClient.query({
    query: GetAdDistributionManagementDocument,
    variables: {
      destination: AdDeliveryDestination.Article1,
    },
  })

  await apolloClient.query({
    query: GetAdDistributionManagementDocument,
    variables: {
      destination: AdDeliveryDestination.Article2,
    },
  })

  if (process.env.NODE_ENV === 'production') {
    await new Promise((resolve) => setTimeout(resolve, 1000))
  }

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      nextSeo: nextSeoValues,
    },
    revalidate: 600,
  }
}

export async function getStaticPaths() {
  const apolloClient = initializeApollo()

  const result = await apolloClient.query({
    query: GetArticlePageDocument,
  })
  const paths = result.data.articles.map((article: ArticleFragment) => ({
    params: { id: article.id },
  }))

  return {
    paths,
    fallback: 'blocking',
  }
}
